var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80087 20.199C8.28823 20.7119 7.59279 21 6.86764 21H3V17.1564C3 16.432 3.28753 15.7373 3.79944 15.2248M8.80087 20.199L3.79944 15.2248M8.80087 20.199L18.7742 10.2212M3.79944 15.2248L13.7826 5.22963M13.7826 5.22963L15.2088 3.80175C16.2762 2.73304 18.0081 2.73271 19.076 3.80102L20.2023 4.92782C21.2692 5.99518 21.2692 7.72521 20.2023 8.79258L18.7742 10.2212M13.7826 5.22963L18.7742 10.2212",
    stroke: "#0F172B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.0adad7f23de1271037f10f503def0482.svg";
export { ForwardRef as ReactComponent };